<template>
  <div></div>
</template>

<script>
export default {
  name: "MaintenanceUnlock",
  created() {
    const key = this.$route.params.key;
    if (key) {
      this.$store.commit("Auth/SET_MAINTENANCE_KEY", key);
    }
    this.$router.replace("/login");
  }
};
</script>
